import { requestBuilder } from '../../http/RequestBuilder';
import type { GeneralResponse } from '../../http/types/Common';
import type { Provider } from '../types/HolisticSummary';

interface UseToggleAccountVisibilityBody {
    accountId: string;
    isHidden: boolean;
    provider: Provider;
}

const useToggleAccountVisibility = requestBuilder.mutation<
    GeneralResponse,
    UseToggleAccountVisibilityBody
>({
    endpoint: '/api/holistic/hide-account',
    method: 'PATCH',
});

export default useToggleAccountVisibility;
